import React from 'react';
import { Button, ButtonVariants } from '../../../Atoms/Button';

type ButtonGroupButtonType = {
  key: string;
  placeholder: string;
  id: string;
};

interface BORDERED_LIST_PROPS {
  buttonData: ButtonGroupButtonType[];
  activeValue: string;
  onClick?: () => void;
  city: string;
}

export const LinkTabs = ({
  buttonData,
  activeValue,
  city,
}: BORDERED_LIST_PROPS): JSX.Element => {
  return (
    <nav className=" py-2 text-left fixed top-16 w-full bg-white sm:hidden z-10">
      <div className="pt-3 shadow-sm ">
        <div className="wg-container">
          {buttonData?.map((button) => {
            return (
              <a href={`/${button.id}-${city}`} key={button.key}>
                <Button
                  rounded=""
                  id={button.key}
                  key={button.key}
                  name={button.placeholder}
                  variant={ButtonVariants.tab}
                  className={` ${
                    button.key === activeValue ? null : 'button-noborder'
                  } `}
                >
                  {button.placeholder}
                </Button>
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
